export const createStripeSetupIntent = `mutation createStripeSetupIntent {
  stripeSetupIntent
}`
